import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import OnePageProducts from './pages/OnePageProducts';
import Dashboard from './pages/Dashboard';
import DashboardCliente from './pages/DashboardCliente';
import Licenses from './pages/Licenses';
import MyOrders from './pages/MyOrders';
import LuaEncrypt from './pages/LuaEncrypt';
import Products from './pages/Products';
import Clients from './pages/Clients';
import Users from './pages/Users';
import Cart from './pages/Cart';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import ProductDetail from './pages/ProductDetail';
import MainLayout from './layouts/MainLayout';
import PublicLayout from './layouts/PublicLayout';

function App() {
  const jwt = localStorage.getItem('jwt');
  const userStr = localStorage.getItem('user');
  let user = null;
  try {
    user = userStr ? JSON.parse(userStr) : null;
  } catch {
    user = null;
  }
  const isAuth = !!jwt && !!user;
  const role = String(user?.role || '').toLowerCase();
  const isStaff = ['admin', 'owner', 'dueno', 'dueño'].includes(role);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
        <Route path="/register" element={<PublicLayout><Register /></PublicLayout>} />
        <Route path="/" element={<PublicLayout><OnePageProducts /></PublicLayout>} />
        <Route path="/dashboard" element={
          isAuth && user ? (
            <MainLayout>
              {isStaff ? <Dashboard /> : <DashboardCliente />}
            </MainLayout>
          ) : <Navigate to="/login" />
        } />
        <Route path="/licenses" element={isAuth ? <MainLayout><Licenses /></MainLayout> : <Navigate to="/login" />} />
        <Route path="/orders" element={isAuth ? <MainLayout><MyOrders /></MainLayout> : <Navigate to="/login" />} />
        <Route path="/products" element={isAuth && isStaff ? <MainLayout><Products /></MainLayout> : isAuth ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
        <Route path="/clients" element={isAuth && isStaff ? <MainLayout><Clients /></MainLayout> : isAuth ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
        <Route path="/users" element={isAuth && isStaff ? <MainLayout><Users /></MainLayout> : isAuth ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
        <Route path="/encrypt-lua" element={isAuth && isStaff ? <MainLayout><LuaEncrypt /></MainLayout> : isAuth ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} />
        <Route path="/cart" element={<PublicLayout><Cart /></PublicLayout>} />
        <Route path="/product/:id" element={<PublicLayout><ProductDetail /></PublicLayout>} />
        <Route path="/payment/success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
        <Route path="/payment/cancel" element={<PublicLayout><PaymentCancel /></PublicLayout>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
